/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Failed_ToastInputs */

const en_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes failed to paste.`)
};

const fr_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec du collage des attributs.`)
};

const de_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute konnten nicht eingefügt werden.`)
};

const it_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile incollare gli attributi.`)
};

const ru_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось вставить атрибуты.`)
};

const es_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron pegar los atributos.`)
};

const zh_cn2_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性粘贴失败。`)
};

const ja_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性を貼り付けることができませんでした。`)
};

const hi_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एट्रिब्यूट पेस्ट करने में विफल रहे।`)
};

const pt_pt2_paste_attributes_failed_toast = /** @type {(inputs: Paste_Attributes_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os atributos não puderam ser colados.`)
};

/**
* | output |
* | --- |
* | "Attributes failed to paste." |
*
* @param {Paste_Attributes_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_failed_toast = /** @type {((inputs?: Paste_Attributes_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_failed_toast(inputs)
	if (locale === "de") return de_paste_attributes_failed_toast(inputs)
	if (locale === "it") return it_paste_attributes_failed_toast(inputs)
	if (locale === "ru") return ru_paste_attributes_failed_toast(inputs)
	if (locale === "es") return es_paste_attributes_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_failed_toast(inputs)
	if (locale === "ja") return ja_paste_attributes_failed_toast(inputs)
	if (locale === "hi") return hi_paste_attributes_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_failed_toast(inputs)
	return en_paste_attributes_failed_toast(inputs)
});